<template>
    <card-list>

        <subheader-list-item icon="fa-align-left" title="Customize"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <template #message v-if="template">{{ template.title }}</template>
                        <b-input v-model="addon.override_title"/>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Single Cost" label-position="inside">
                        <template #message v-if="template">{{ template.single_cost | currency }}</template>
                        <b-input v-model="addon.override_price"/>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Double Cost" label-position="inside">
                        <template #message v-if="template">{{ template.double_cost | currency }}</template>
                        <b-input v-model="addon.override_price_double"/>
                    </b-field>
                </div>
            </div>
        </container-list-item>
        <subheader-list-item icon="fa-credit-card-front" title="Payment Plan"/>

        <container-list-item padded>
            <div v-if="isnew && !hasplan">
                <i class="fas fa-exclamation-circle mr-2"></i>This registration has no payment plan, so the add-on can't be billed here.
                It will be recorded on the registration only — collect the cost on whichever registration carries the payment plan.
            </div>
            <div v-else-if="isnew">
                <div class="columns">
                    <div class="column">
                        <b-field>
                            <b-switch :true-value="1" :false-value="0" v-model="addon.plan_item">Adjust Registration Total and Create a Plan Item</b-switch>
                        </b-field>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <b-field label="Recalculation Strategy" label-position="inside">
                            <b-select expanded v-model="addon.strategy">
                                <option value="today">New Plan Item Due Today</option>
                                <option value="next">Adjust Next Installment Payment</option>
                                <option value="last">Adjust Last/Final Installment Payment</option>
                                <option value="spread">Spread Cost Over Remaining Installment Plan Items</option>
                            </b-select>
                        </b-field>
                    </div>
                </div>
            </div>
            <div v-else>
                <i class="fas fa-exclamation-circle mr-2"></i>When editing or deleting an add-on, customizing the cost will not change the registration's cost or payment plan items.
                These will need to be adjusted manually if necessary.
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    export default {
        name: 'AddonForm',
        props: {
            addon: {
                type: Object,
                required: true
            },
            template: {
                type: Object,
                required: false
            },
            isnew: Boolean,
            // Registrations created with "No Payment Plan" have nothing to bill against.
            hasplan: {
                type: Boolean,
                default: true
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList}
    };

</script>

<style scoped>

</style>
